import Decimal from './break_infinity.js';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators.js';
import global_css from './global-css';
import {Modal} from './modal';
import {Plot} from './plot';
import {ri, RunnerIdle} from './runner-idle';
import {UnlockableLitElement} from './unlockable-lit-element';
import {RIGHT} from 'p5';
export default function () {
  const settings = document.querySelector('ri-settings') as Settings;
  settings.oldGameSpeed = ri.gameSpeed;
  ri.gameSpeed = 0;
  if (settings) {
    const modal = settings.shadowRoot?.querySelector('ri-modal') as Modal;
    if (modal) {
      modal.open();
      (settings.shadowRoot?.getElementById('main-plot') as Plot)?.plot();
    }
  }
}

type Preferences = keyof RunnerIdle['settings'];

@customElement('ri-settings')
export class Settings extends LitElement {
  oldGameSpeed = 0;
  exportSave() {
    const textarea = this.shadowRoot?.getElementById(
      'export-save'
    ) as HTMLTextAreaElement;
    if (textarea) textarea.value = btoa(JSON.stringify(ri.saveGame));
  }

  importSave() {
    const textarea = this.shadowRoot?.getElementById(
      'import-save'
    ) as HTMLTextAreaElement;
    if (textarea) ri.load(JSON.parse(atob(textarea.value)));
  }

  close() {
    (this.shadowRoot?.querySelector('ri-modal') as Modal)?.close();
    this.unpause();
  }

  toggle(prop: Preferences, force?: boolean) {
    ri.settings[prop] = force ?? !ri.settings[prop];
    ri.requestUpdate();
    this.requestUpdate();
  }

  unpause() {
    const runnerIdle = document.querySelector('runner-idle') as RunnerIdle;
    if (runnerIdle) {
      runnerIdle.gameSpeed = this.oldGameSpeed;
    }
  }

  static override styles = [
    global_css,
    css`
      * {
        transition: all 0.2s ease-in-out;
      }
      .header {
        font-size: 1.2rem;
      }
      .content {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
      }

      .modal {
        background-color: red;
      }
      button {
        background-color: #fff4;
      }

      .toggled {
        background-color: green;
        color: white;
      }
      .toggled:hover {
        background-color: darkgreen;
      }
    `,
  ];

  protected override render() {
    return html`
      <ri-modal .closeOnOverlay=${true} .onClose=${this.unpause}>
        <div class="container">
          <div class="save-management">
            <div class="header">Save Management</div>
            <div class="content">
              <button @click=${this.exportSave}>Export Save</button>
              <button @click=${this.importSave}>Import Save</button>
              <button
                @click=${() => {
                  if (
                    window.confirm(
                      'Do you really want to delete your save? THIS IS IRREVERSIBLE.'
                    )
                  ) {
                    document.querySelector('runner-idle')?.resetSave();
                  }
                }}
                class="danger"
              >
                HARD RESET
              </button>
              <textarea
                placeholder="Exported Save"
                readonly
                id="export-save"
              ></textarea>
              <textarea
                placeholder="Save to Import"
                id="import-save"
              ></textarea>
            </div>
          </div>
          <div class="emergencies">
            <div class="header">Emergencies</div>
            <div class="content">
              <button
                @click=${() => {
                  ri.loadPanels();
                }}
              >
                Reset Layout
              </button>
            </div>
          </div>
          <div class="social">
            <div class="header">Social</div>
            <button
              @click=${() => window.open('https://discord.gg/WS87ea4gQY')}
            >
              Discord
            </button>
          </div>
          <button class="big" @click=${this.close}>Close (ESC)</button>
        </div>

        <input
          type="text"
          style="width: 100px"
          @input=${(event: Event) => {
            if (!(event.target instanceof HTMLInputElement)) return;
            if (
              location.hostname == 'localhost' ||
              event.target.value == 'brackets'
            ) {
              if (event.target.nextElementSibling instanceof HTMLElement) {
                event.target.nextElementSibling.hidden = false;
              }
              event.target.hidden = true;
              ri.isDev$.next(true);
            }
          }}
        />
        <div
          class="container"
          ?hidden=${!['localhost', 'rpgcubed.itch.io'].includes(
            location.hostname
          )}
        >
          <button
            @click=${() =>
              ri.resources.time.baseValue$.next(ri.resources.time.capacity)}
          >
            Max Time
          </button>
          <button
            @click=${() => {
              ri.unlockables.forEach((unlockable: UnlockableLitElement) =>
                unlockable.tryUnlock(true)
              );
              ri.distance = new Decimal('1e6');
            }}
          >
            Unlock all unlockables
          </button>
          <button @click=${ri.reincarnate}>Reincarnate</button>
        </div>
      </ri-modal>
    `;
  }
}
